<template>
  <q-page>
    <div class="pageContent">  
      <div class="row">
          <q-card class="col-12 chart">
            <q-card-section class="text-weight-bold">
              {{$t('global.StrategyDashboard')}}
              <q-btn color="primary" class="float-right" :label="$t('global.Refresh')" @click="getMileStones"/>
            </q-card-section>
            
            <q-card-section>
              <div v-for="mileStone in mileStones" v-bind:key="mileStone.name">
                <GChart
                  :settings="{ packages: ['corechart', 'table', 'map'] }"
                  type="ComboChart"
                  :data="mileStone.chartData"
                  :options="mileStone.chartOptions"
                />
                <div class="row pageContent" >
                  <div class="col">
                    <q-input readonly :label="$t('global.Owner')" :value="mileStone.chartInfo.owner"  />
                  </div>
                  <div class="col">
                    <q-input readonly :label="$t('global.Performance')" :value="mileStone.chartInfo.performance"  />
                  </div>
                  <div class="col">
                    <q-input readonly :label="$t('global.AverageReduction')" :value="mileStone.chartInfo.average_reduction"  />
                  </div>
                  <div v-if="true" class="col">
                    <q-input readonly :label="$t('global.TotalPerformance')" :value="mileStone.chartInfo.totperf"  />
                  </div>
                </div>
                
              </div>
            </q-card-section>
          </q-card>
        </div>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import { GChart } from 'vue-google-charts'

var msData = [
  ['Month', 'Real', 'Planed', 'Performance', 'P-Line'],
  ['2019/01',  160,      120,         -40, -40],
]
 
var msChartOption = {
  title : 'Analytics Speed Alert 1, 2019, Performance.  6/6. Average reduction 10%. Total reduction 8%',
  vAxis: {title: 'Alerts'},
  //hAxis: {title: 'Period'},
  hAxis: {},
  seriesType: 'bars',
  series: {3: {type: 'line'}}, //Changes performace to line
  colors:['blue','#ffca28','red', 'red'],
  //chartArea: {left: 25, width: '85%'}
  chartArea: {left: 25, right: 150},  
}

import axios from 'axios'
import qs from 'qs'

export default {
  name: 'User',
  data: function () {
    return {
      form: {
        SessionId: null,
      },
      chartData: msData,
      mileStones:[],
      dateFrom: this.moment().toDate(),
    }
  },
  methods: {
    getMileStones(){
      this.mileStones = []

      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetMilestoneDetailAll"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
        if(response.status == 200){ 
          var MileStoneID = 0
          var dataArray = response.data
          for (let i = 0; i < dataArray.length; i++) {
            var ms = dataArray[i]
          
            //New Milestone:
            if(MileStoneID != ms.MileStoneID){ 
              console.log('begin new milestone: ' + ms.MileStoneID) 
              var totalCount = 0
              var totalAchived = 0
              var firstReal = ms.Real
              var totalReal = 0
              var totalGoal = 0
              var msDataNew = [['Month', 'Real', 'Planed', 'Performance', 'P-Line']]
            }
            //series data processing:
            console.log('MileStoneID: ' + ms.MileStoneID + ' MileStoneDetailID: ' + ms.MileStoneDetailID)
            //var hAxisLabel = ms.Start.substr(0,10) + ' ' + ms.Ending.substr(0,10)
            var hAxisLabel = this.moment(ms.Start).format('MM/DD/YYYY') + ' ' + this.moment(ms.Ending).format('MM/DD/YYYY')
                
            if(ms.Real != 0){
              totalReal += ms.Real
              totalGoal += ms.Goal
              totalCount++
              if(ms.Goal > ms.Real)
                totalAchived++
              var perf = ms.Goal - ms.Real
            }
            else{
              var perf = 0
            }
            
            msDataNew.push([hAxisLabel, ms.Real, ms.Goal, perf, perf])

            //End of series, insert milestone:
            if(i == dataArray.length - 1 || ms.MileStoneID != dataArray[i + 1].MileStoneID){
              //var totperf = round(100 / firstReal * ms.Real,0) + '%'
              var totperf = round((totalReal - totalGoal) / totalReal * 100 ,2)
              var avgPerf = round(totperf / (i + 1),2)
              
              var cOptions = {...msChartOption}
              cOptions.title = ms.MilestoneName + ' - ' + this.$t('global.Alert') + ': ' + ms.AlertConfigName
              this.mileStones.push({name: ms.MilestoneName, chartData: msDataNew, chartOptions: cOptions, chartInfo: {owner: ms.Owner, performance: totalAchived + ' / ' + totalCount,average_reduction: avgPerf + '%', totperf: totperf + '%'} })
              console.log('end milestone: ' + ms.MileStoneID)
            }
            
            //last statement in processing, update flag:
            MileStoneID = ms.MileStoneID
          }
          setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
        }
        else{
            this.$q.notify('Something Wrong.')
        }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e); 
      })
    }
  },
  components: {
    GChart
  },
  mounted() {
    this.getMileStones()
  },  
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>
<style scoped>
.content{
  padding: 5px;
}
.pageContent{
  padding: 10px;
}
.chart{
  width: 100%;
}
</style>
